/**
 * QR / link campaign offer — loaded only when Theme settings → Campaign offer is on (snippets/campaign-offer.liquid).
 *
 * Landing with ?offer=<key>:
 *   - applies the discount code (/discount/<code>), shows the campaign popup once
 *   - stores the visit (plus utm_*) in localStorage for 30 days
 * Every page while the visit is remembered:
 *   - re-applies the code once per browser session
 *   - keeps _campaign / _utm_* on the cart so the order carries them (Shopify Flow tags the customer)
 */
(function () {
  "use strict";

  var RF = (window.RF = window.RF || {});
  var cfg = RF.campaign;
  if (!cfg) return;

  var STORE_KEY = "rf-campaign";
  var DISCOUNT_KEY = "rf-campaign-discount:" + cfg.code;
  var TTL = 30 * 864e5;
  var UTM = ["utm_source", "utm_medium", "utm_campaign", "utm_content"];

  function load() {
    try {
      var v = JSON.parse(window.localStorage.getItem(STORE_KEY) || "null");
      if (v && v.key === cfg.key && Date.now() - v.at < TTL) return v;
    } catch (e) {}
    return null;
  }

  function save(v) {
    try {
      window.localStorage.setItem(STORE_KEY, JSON.stringify(v));
    } catch (e) {}
  }

  var params = new URLSearchParams(window.location.search);
  var offer = (params.get("offer") || "").toLowerCase();
  var landing = offer === cfg.key;
  var visit = load();

  if (landing) {
    visit = { key: cfg.key, at: Date.now(), utm: {} };
    UTM.forEach(function (k) {
      if (params.get(k)) visit.utm[k] = params.get(k).slice(0, 100);
    });
    save(visit);
  }
  if (!visit) return;

  function applyDiscount(force) {
    try {
      if (!force && window.sessionStorage.getItem(DISCOUNT_KEY)) return Promise.resolve();
    } catch (e) {}
    return fetch("/discount/" + encodeURIComponent(cfg.code), { credentials: "same-origin" })
      .then(function () {
        try {
          window.sessionStorage.setItem(DISCOUNT_KEY, "1");
        } catch (e) {}
      })
      .catch(function () {});
  }

  function syncCartAttributes() {
    var wanted = { _campaign: cfg.tag };
    UTM.forEach(function (k) {
      if (visit.utm && visit.utm[k]) wanted["_" + k] = visit.utm[k];
    });
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var have = cart.attributes || {};
        var stale = Object.keys(wanted).some(function (k) {
          return have[k] !== wanted[k];
        });
        if (!stale) return;
        return fetch("/cart/update.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ attributes: wanted }),
        });
      })
      .catch(function () {});
  }

  applyDiscount(landing).then(syncCartAttributes);

  // Shopify customer events: lets a custom pixel forward the landing to GA4 / ads if wanted
  try {
    if (landing && window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
      Shopify.analytics.publish("rf_campaign_landing", { campaign: cfg.tag, code: cfg.code, utm: visit.utm });
    }
  } catch (e) {}

  if (!landing) return;

  function initModal() {
    var modal = document.querySelector("[data-campaign-modal]");
    if (!modal) return;

    function close() {
      modal.hidden = true;
      modal.setAttribute("aria-hidden", "true");
      modal.classList.remove("is-open");
      document.documentElement.classList.remove("rf-upsell-open");
    }

    modal.addEventListener("click", function (e) {
      if (e.target.closest("[data-campaign-dismiss]")) {
        close();
        return;
      }
      var copy = e.target.closest("[data-campaign-copy]");
      if (copy && navigator.clipboard) {
        navigator.clipboard.writeText(cfg.code).then(function () {
          var hint = modal.querySelector("[data-campaign-copy-hint]");
          if (hint) hint.textContent = "Copied! Also applied automatically at checkout";
        });
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modal.classList.contains("is-open")) close();
    });

    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
    modal.classList.add("is-open");
    document.documentElement.classList.add("rf-upsell-open");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initModal);
  } else {
    initModal();
  }
})();
